module.exports = __webpack_public_path__ + "static/media/illustration_login.58f1acbd.svg";